import type { ArticleBlock, ArticleData, InternalAsset, InternalNodeCamelCase } from '../entities/article';
import type { StoryCategory } from '@benzinga/advanced-news-manager';

export const findPrimaryImage = (assets: InternalAsset) => {
  if (Array.isArray(assets) && assets.length) {
    for (const asset of assets) {
      if (asset.type === 'image' && asset.primary) {
        if (asset.attributes?.filepath) {
          return 'https://www.benzinga.com/' + asset.attributes.filepath;
        }
        if (asset.url) {
          return asset.url;
        }
      }
    }
  }
  return '';
};

export const getSecFormType = (Tags: StoryCategory[]): string | null => {
  let found: string | null = null;
  if (Tags && Tags.length) {
    Tags.forEach(tag => {
      if (tag.vid === 12) {
        found = tag.name;
        return;
      }
    });
  }
  return found;
};

export const injectOptinMonsterInArticlePlaceholder = (articleBlocks: ArticleBlock[]) => {
  if (!Array.isArray(articleBlocks) || articleBlocks?.length < 4) return articleBlocks;

  const injectedBlock = {
    attrs: {
      ids: ['om-sgyzzeizskvbrtpwegkk-holder', 'om-bqz3ksge7qwckmhxxv4l-holder'],
    },
    blockName: 'optinmonster-placeholder',
  };

  const getParagraphCount = () => {
    const result = articleBlocks.filter((block: ArticleBlock) => block?.tag === 'p');
    return result?.length ?? 0;
  };

  const generateNewBlocks = () => {
    const paragraphCount = getParagraphCount();
    const result = [...articleBlocks];
    if (paragraphCount >= 4) {
      result.splice(2, 0, injectedBlock as ArticleBlock);
    }
    return result;
  };

  const newBlocks = generateNewBlocks();

  return newBlocks;
};

export const formatArticleSurrogateKeys = (nid: string): string => {
  if (!nid) return '';

  const surrogateKeys = ['article', `/node/${nid}`, `nid:${nid}`];

  return surrogateKeys.join(' ');
};

const DISABLE_CAMPAIGNIFY_UNIT_AUTHOR_IDS = [178351];

export const shouldDisableCampaignifyUnit = (article: ArticleData, isDisabledFromLayout: boolean) => {
  if (isDisabledFromLayout) {
    return isDisabledFromLayout;
  }
  const userId = article.author?.uid || (article as InternalNodeCamelCase).userId;

  if (userId && DISABLE_CAMPAIGNIFY_UNIT_AUTHOR_IDS.includes(userId)) {
    return true;
  }
  return false;
};
